import _merge from 'lodash/merge';
import defaultLocaleData from '../../../../lang/customer/bedrock/en.json';
import customerLocaleData from '../../../../lang/customer/rtlde/de.json';
import languages from '../../../../lang/languageNames/de.json';

const dictionary = _merge(defaultLocaleData, customerLocaleData);

export { dictionary, languages };
